import React, { useEffect, useState } from "react";

import { Button, Row, Col, Input, Form } from "antd";
import { useSignInMutation, useValidateTokenMutation } from "../../../redux/services/userApi";
import { useDispatch, useSelector } from "react-redux";
import { setAuthData } from "../../../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { RootState } from "../../../redux/store";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");

  const [signIn, { isLoading }] = useSignInMutation();
  const accessToken = useSelector((state: RootState) => state?.auth?.accessToken);

  const [validateToken, { isLoading: tokenValidationInProgress, isError }] =
    useValidateTokenMutation();

  const handleSignIn = async () => {
    try {
      const response: any = await signIn({
        mobile: mobile,
        password: password
      });

      const accessToken = response?.data?.meta?.response?.headers?.get("access-token");
      const client = response?.data?.meta?.response?.headers?.get("client");
      const uid = response?.data?.meta?.response?.headers?.get("uid");
      const user = response?.data?.apiResponse?.user;

      dispatch(setAuthData({ accessToken, client, uid, user }));
      navigate("/");
    } catch (error) {
      // Handle sign-in error
    }
  };

  useEffect(() => {
    async function checkAccessToken() {
      if (accessToken) {
        try {
          await validateToken({}).unwrap();
          navigate("/");
        } catch (error) {
          dispatch(setAuthData({ accessToken: null, client: null, uid: null, user: null }));
        }
      }
    }

    checkAccessToken();
  }, [accessToken, dispatch]);

  if (tokenValidationInProgress) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh"
        }}
      >
        <LoadingOutlined style={{ fontSize: 24 }} spin />
      </div>
    );
  }

  const CustomFormLabel = ({ label }: any) => <span style={{ fontWeight: 500 }}>{label}</span>;

  return (
    <Row style={{ height: "100vh", width: "100vw", rowGap: 100 }}>
      <Col sm={24} md={24} lg={12}>
        <Row style={{ paddingLeft: "100px", paddingRight: "100px" }}>
          <Col sm={24} style={{ marginTop: 40 }}>
            <img src="/assets/logo.svg" alt="logo" width={200} height={38} />
          </Col>
          <Col sm={24} style={{ marginTop: 100 }}>
            <h1>EV CHARGER WORKFLOW MANAGEMENT SYSTEM</h1>
          </Col>
          <Col sm={24} style={{ marginTop: 60 }}>
            <h3>Login</h3>
          </Col>
          <Col sm={24} style={{ marginTop: 30 }}>
            <Form name="user_form" labelCol={{ span: 24 }} autoComplete="off">
              <Form.Item
                label={<CustomFormLabel label="Mobile Number" />}
                name="Mobile Number"
                rules={[
                  { required: true, message: "Please input mobile number" },
                  { min: 10, message: "Mobile No. must be minimum 10 characters." },
                  { max: 10, message: "Mobile No. be maximum 10 characters." },
                  { pattern: /^[0-9]+$/, message: "Mobile No. must contain only numbers." }
                ]}
              >
                <Input
                  size="large"
                  placeholder="Mobile Number"
                  onChange={(e) => setMobile(e.target.value)}
                />
              </Form.Item>

              <Form.Item
                label={<CustomFormLabel label="Password" />}
                name="Password"
                rules={[{ required: true, message: "Please input password" }]}
              >
                <Input.Password
                  size="large"
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Item>
            </Form>
          </Col>
          <Col sm={24}>
            <Button disabled={isLoading} onClick={handleSignIn}>
              Login
            </Button>
          </Col>
        </Row>
      </Col>

      <Col lg={12} sm={24} md={24}>
        <img
          src="/assets/banner-ecb.svg"
          alt="banner-image"
          title="banner-img"
          width={"100%"}
          height={"100%"}
        />
      </Col>
    </Row>
  );
};
export default Login;
